export default __webpack_public_path__ + "static/media/man3.51fddb76.jpg";